import { Pipe, PipeTransform } from '@angular/core';
import { Ticket, TicketThreadEntryAttachment } from '@zero/shared/util-models';
import { environment } from 'environments/environment';

@Pipe({
  name: 'attachmentLink',
  standalone: true,
})
export class AttachmentLinkPipe implements PipeTransform {
  public transform(attachment: TicketThreadEntryAttachment, ticket: Ticket): string {
    const { threadId, attachmentId, name } = attachment;
    const baseUrl = `${environment.apihost + environment.ticketdialog}/ticket/${ticket.deskTicket.id}`;

    return threadId
      ? `${baseUrl}/thread/${threadId}/attachment/${attachmentId}/${encodeURI(name)}`
      : `${baseUrl}/attachment/${attachmentId}/${encodeURI(name)}`;
  }
}
